<template>
  <div class="guest" data-scroll-section>
    <GiestTitle :title="title"></GiestTitle>
    <GuestList :scroll="scroll"/>
  </div>
</template>

<script>
import GiestTitle from '@/components/guest/GuestTitle'
import GuestList from '@/components/guest/GuestList'
export default {
  data () {
    return {
      title: {
        en: 'SPEAKERs',
        zh: '大会嘉宾'
      }
    }
  },
  components: {
    GiestTitle,
    GuestList
  },
  props: {
    scroll: Object
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/guest/index.less");
</style>